// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__bxic7","insightsList":"newBusinessInsightsMenu_insightsList__CW3Xw","active":"newBusinessInsightsMenu_active__3gYGd"};